<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> AV Prüfung </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">AV Prüfung</li>
              </ul>
            </div>
          </div>
          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row center-block">
              <div class="col-md-12">
                <div class="card mb-0">
                  <div class="card-body">
                    <div id="surveyContainer">
                      <survey :survey="survey">
                      </survey>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DDKModal
              title="Bitte die Prüfergebnisse bestätigen"
              v-if="showConfirm"
              width="50%"
              @close ="showConfirm = false"
              :before-close="handleClose">
              <h4 slot="header">Prüfbericht: DDK - {{ accountName }} - {{ reportDate }}</h4>
              <div slot="body">
                <div v-for="(value, key) in organizedResult">
                  <div class="row" style="margin: 5px">
                    <h5 class="dialogtitle">{{ value.title }}</h5>
                  </div>
                  <table>
                    <tr>
                      <td>Prüfpunkte</td>
                      <td>Frage</td>
                      <td>Antwort</td>
                      <td>Bemerkungen</td>
                    </tr>
                    <tr v-for="(item, index) in value['content']" :key="index">
                      <th>
                        <span>
                          <i v-if="item.result === 'passed'" class="el-icon-circle-check-outline igreen"></i>
                          <i v-else class="el-icon-circle-close-outline ired"></i>
                          {{item.points}}
                        </span>
                      </th>
                      <th>
                        <span>
                          <p>{{ item.question }}</p>
                        </span>
                      </th>
                      <th>
                        <span>
                          <p>{{ item.answer }}</p>
                        </span>
                      </th>
                      <th>
                        <span>
                          <p>{{ item.comment }}</p>
                        </span>
                      </th>
                    </tr>
                  </table>
                  <div><br></div>
                </div>
                <div>
                  <input
                    type="textarea"
                    :rows="2"
                    placeholder="Kommentar für den Bericht"
                    v-model="surveyComment">
                  <!--<ckeditor :editor="editor" v-model="surveyComment" ></ckeditor>-->
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <button class="btn btn-secondary btn-sm" @click="showConfirm=false">Abbrechen</button>
                <button class="btn btn-primary btn-sm" type="primary" @click="confirmResult">Bestätigen</button>
              </span>
            </DDKModal>
            <DDKModal
              title="Prüfung Ergebnisse der TOM"
              v-if="showTOMResult"
              width="50%"
              @close ="showTOMResult = false"
              :before-close="handleClose">
              <h4 slot="header">TOM Prüfergebnisse</h4>
              <div slot="body">
                <div v-html="tomResult">
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <button class="btn btn-secondary btn-sm" @click="showTOMResult=false">Schließen</button>
              </span>
            </DDKModal>
            <div class="surveyMenu" v-if="false">
              <el-dropdown split-button type="warning" size="medium" @command="gotoPage" @click="searchPageVisible=!searchPageVisible">
                <i class="el-icon-search" style="margin-right: 10px"></i>Suche
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(page, index) in survey_pages" :key="index" :command="index">{{ page.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="col-sm-2" style="margin: 20px 0;"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showValidationPopup" class="validation-tooltip" :style="{ top: popupY + 'px', left: popupX + 'px' }" @click.stop>
      <div class="validation-close" @click="closeValidationPopup">&times;</div>
      <div v-html="validationPopupContent" class="validation-content"></div>
    </div>
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue'
import {mapState, mapGetters} from 'vuex'
import service from '../../utils/request.js'
import Questions from '../../utils/avcheck_questions'
import QuestionList from './QuestionList.vue'
import DDKModal from '@/components/component/Modal'
import markdownit from "markdown-it";

var Survey = SurveyVue.Survey
const failed = 'ff0000'
const passed = '00ff00'
const others = 'ffff00'
export default {
  name: 'SurveyContent',
  components: {
    Survey,
    DDKModal,
    // ckeditor : CKEditor.component
  },
  props: ['surveyID', 'surveyJson','partnerName', 'partnerAddress', 'contractName', 'gapInput', 'statusSign', 'filename', 'auftragsgeber', 'remarks', 'partnerID', 'surveyResult', 'resultObject'],
  data: function() {
    // const converter = new showdown.Converter();
    // this.surveyJson.pages.forEach((page) => {
    //   page.elements.forEach((element) => {
    //     if (element.type !== 'html'){
    //       if ('description' in element) {
    //         let str = converter.makeHtml(element.description);
    //         // remove root paragraphs <p></p>
    //         str = str.substring(3);
    //         str = str.substring(0, str.length - 4);
    //         // set html
    //         element.description = str;
    //       }
    //     }
    //   })
    // })
    var model = new SurveyVue.Model(this.surveyJson)
    var survey_menu = this.surveyJson['pages']
    const md = new markdownit({
      html: true,
      linkify: true, // Optional: auto-convert URL-like text to links
      typographer: true // Optional: beautify quotes and dashes
    });
    // Survey.cssType = 'bootstrap'
    var myCss = {
      'question': {
        'title': 'questiontitle',
        'hasError': 'has-error'
      },
      'navigationButton': 'button btn-lg',
      'error': {
        'root': 'alert alert-danger',
        'icon': 'glyphicon glyphicon-exclamation-sign',
        'item': '',
        'locationTop': 'sv_qstn_error_top',
        'locationBottom': 'sv_qstn_error_bottom'
      }
    }
    const that = this
    if (this.surveyData) {
      model.data = JSON.parse(this.surveyData)
    }
    model.onAfterRenderQuestion.add((sender, options) => {
      const commentEl = options.htmlElement.querySelector(".sd-question__comment-area");
      if (options.question.hasComment && options.question.name !== 'tomsvertraulichkeit' && that.resultObject.validations[options.question.name]) {
        if (commentEl) {
          const validationBtn = document.createElement("span");
          validationBtn.innerHTML = '<i aria-hidden="true" class="fa fa-info-circle"></i>'; // Information icon
          validationBtn.className = "text-primary"; // Optional: use your preferred bootstrap class
          validationBtn.style.marginLeft = "10px";
          validationBtn.style.cursor = "pointer";
          validationBtn.title = "Validierung anzeigen";

          // On click, convert markdown to HTML and show popup
          validationBtn.onclick = (event) => {
            event.stopPropagation(); // Prevent bubbling
            that.validationPopupContent = md.render(that.resultObject.validations[options.question.name]);
            const rect = commentEl.getBoundingClientRect();

            // Set position: Left-aligned with the comment field, slightly above it
            that.popupX = rect.left + window.scrollX;
            that.popupY = rect.top + window.scrollY - 10; // 10px buffer above the field

            that.showValidationPopup = true;

            // Listen for clicks outside the popup to close it
            setTimeout(() => {
              document.addEventListener('click', that.closeValidationPopupIfOutside);
            }, 0);
          };

          // Insert the icon after the comment label
          const commentLabel = commentEl.querySelector(".sv-string-viewer");
          if (commentLabel) {
            commentLabel.appendChild(validationBtn);
          }
        }
      }
      if (options.question.hasComment && options.question.name === 'tomsvertraulichkeit') {
        if (commentEl) {
          // Create the icon button
          const iconButton = document.createElement("span");
          iconButton.innerHTML = '<i class="fa-regular fa-lightbulb"></i>'; // Info icon (you can use FontAwesome or other icon libraries)
          iconButton.className = "dkl-red";
          iconButton.style.marginLeft = "5px";
          iconButton.style.cursor = "pointer";
          iconButton.title = "Klick für die Erklärung";

          // Add click event to show popup
          iconButton.onclick = (event) => {
            event.stopPropagation(); // Prevent event bubbling

            // Create and show popup
            this.showTOMResult = true
          };

          // Insert the icon after the comment label
          const commentLabel = commentEl.querySelector(".sv-string-viewer");
          if (commentLabel) {
            commentLabel.appendChild(iconButton);
          }
        }
      }
    });
    model.onCompleting.add(
      function(sender, options) {
        if (!that.surveyConfirmed) {
          options.allowComplete = that.completeOption
          that.resultBody = JSON.stringify(sender.data)
          that.fillOrganizedResult(JSON.stringify(sender.data))
          that.showConfirm = true
        }
      }
    )
    model.onValueChanged.add(
      function(sender, options) {
        const survey_result = sender.data
        const key = `av_${that.$store.getters.id}_${that.$store.getters.accountid}`
        localStorage.setItem(that.saveKey + '.data', JSON.stringify(survey_result))
        localStorage.setItem(that.saveKey + '.modified', Date.now().toLocaleString())
      }
    )
    model.onComplete.add(function(result) {
      // that.resultBody = JSON.stringify(result.data);
      // that.submitResult()
    })
    model.css = myCss
    model.completedHtml = '<p><h4>Danke für die Prüfung.</h4></p>'
    model.showPageTitles = true
    model.clearInvisibleValues = 'onHidden'
    // model.onAfterRenderQuestion.add((sender, options) => {
    //   let str = options.htmlElement.querySelector('.sd-question__header .sd-description span.sv-string-viewer').textContent
    //   // str = converter.makeHtml(str);
    //   // remove root paragraphs <p></p>
    //   // str = str.substring(3);
    //   // str = str.substring(0, str.length - 4);
    //   // set html
    //   options.htmlElement.querySelector('.sd-question__header .sd-description').innerHTML = `<div class="sv-string-viewer">${str}</div>`
    // })
    model.onTextMarkdown.add((sender, options) => {
      if (options.name === 'description') options.html = options.text
      if (options.name === 'text' && options.text.includes('Ja')) options.html = `<div class="sd-element-yes">${options.text}</div>`
      if (options.name === 'text' && options.text.includes('Nein')) options.html = `<div class="sd-element-no">${options.text}</div>`
    })
    model.data = this.surveyResult
    return {
      survey: model,
      survey_pages: survey_menu,
      search_keywords: '',
      showConfirm: false,
      showTOMResult: false,
      searchPageVisible: false,
      loading: true,
      completeOption: false,
      surveyConfirmed: false,
      reportDate: Date.now(),
      auditResult: 'passed',
      saveKey: `av_${this.$store.getters.id}_${this.$store.getters.accountid}`,
      generalComment: {
        gegendstandComment: 'k.A.',
        umfangComment: 'k.A.',
        ortComment: 'k.A.',
        verantwortlichenrechtComment: 'k.A.',
        auftragsverarbeiterpflichtComment: 'k.A.',
        tomsComment: 'k.A.',
        unterauftragComment: 'k.A.'
      },
      // editor: ClassicEditor,
      surveyComment: '',
      item: {},
      items: [],
      template: QuestionList,
      surveyResponse: {},
      resultBody: {},
      resultOverview: {},
      resultRelation: {},
      organizedResult: {},
      resultDesc: {},
      surveyConfig: {},
      showValidationPopup: false,
      validationPopupContent: '',
      popupX: 0,
      popupY: 0,
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['accountid', 'accountName', 'username', 'id']),
    ...mapState({customerAddress: state => state.account.address}),
    tomResult (data) {
      if (this.resultObject && this.resultObject.tom_results && Object.keys(this.resultObject.tom_results).length > 0)
      {
        let html = '<table class="table table-striped">';

        // Table headers
        html += '<tr><th>Bereich</th><th>Kategorie</th><th>Maßnahme</th><th>Wertung</th><th>Bemerkung</th></tr>';

        // Process each level 1 item
        for (const [level1Key, level1Value] of Object.entries(this.resultObject.tom_results)) {
          let level1RowCount = 0;

          // Calculate total rows for level1 rowspan
          for (const [level2Key, level2Array] of Object.entries(level1Value)) {
            level1RowCount += level2Array.length;
          }

          let isFirstLevel2 = true;

          // Process each level 2 item
          for (const [level2Key, level2Array] of Object.entries(level1Value)) {
            let isFirstValue = true;

            // Process each array value
            for (const value of level2Array) {
              html += '<tr>';

              // Add level 1 cell with rowspan on first level2 item
              if (isFirstLevel2) {
                html += `<td rowspan="${level1RowCount}">${level1Key}</td>`;
                isFirstLevel2 = false;
              }

              // Add level 2 cell with rowspan on first array value
              if (isFirstValue) {
                html += `<td rowspan="${level2Array.length}">${level2Key}</td>`;
                isFirstValue = false;
              }

              // Add value cell
              html += `<td>${value["measure"]}</td><td>${value["score"]}</td><td>${value["comment"]}</td>`;
              html += '</tr>';
            }
          }
        }

        html += '</table>';
        return html;
      } else {
        return ''
      }
    },
  },
  mounted() {
    this.save_local(),
    this.fillResultDesc()
  },
  methods: {
    fillResultDesc: function() {
      this.surveyJson.pages.forEach((page) => {
        this.resultOverview[page.name] = 0;
        this.organizedResult[page.name] = {
          'color': passed,
          'result': 'passed',
          'points': 0,
          'comment': 'k. A.',
          'title': page.description,
          'description': '',
          'content': []
        };
        page.elements.forEach((element) => {
          let div = document.createElement("div")
          if (element.type !== 'html') {
            this.organizedResult[page.name].content.push({
              'name': element.name,
              'question': element.title,
              'type': element.type,
              'answer': '',
              'comment': '',
              'color': passed,
              'result': 'passed',
            })
            this.resultRelation[element.name] = page.name
            this.resultDesc[element.name] = {}
            element.choices.forEach((choice) => {
              this.resultDesc[element.name][choice.value] = choice.text
            })
          } else {
            div.innerHTML = element.html
            this.organizedResult[page.name]['description'] = div.textContent || div.innerText || ""
          }
        })
      })
    },
    itemClicked: async function(item) {
      const goto_page = this.survey.getPageByName(item.category)
      this.survey.currentPage = goto_page
      this.survey.getQuestionByName(item.name).focus()
      this.searchPageVisible = false
    },
    getLabel: function(item) {
      if (item) {
        return item.title
      }
      return ''
    },
    update: function(text) {
      this.items = Questions.filter((item) => {
        return (new RegExp(text.toLowerCase())).test(item.title.toLowerCase())
      })
    },
    gotoPage: function(command) {
      this.survey.currentPageNo = command
    },
    save_local: function() {
      localStorage.setItem(this.saveKey + '.username', this.username)
      localStorage.setItem(this.saveKey + '.partnerName', this.partnerName)
      localStorage.setItem(this.saveKey + '.partnerAddress', this.partnerAddress)
      localStorage.setItem(this.saveKey + '.partnerID', this.partnerID)
      localStorage.setItem(this.saveKey + '.filename', this.filename)
      localStorage.setItem(this.saveKey + '.contractName', this.contractName)
      localStorage.setItem(this.saveKey + '.auftragsgeber', this.auftragsgeber)
      localStorage.setItem(this.saveKey + '.status', 'processing')
      localStorage.setItem(this.saveKey + '.modified', new Date().toLocaleString())
    },
    hinweiseChange: function(event) {
      if (event.target.checked === true) {
        this.organizedResult[event.target.name]['comment'] = 'Bitte auf Hinweise achten'
      } else {
        this.organizedResult[event.target.name]['comment'] = 'k.A.'
      }
    },
    closeDiaglog: function() {
      this.dialogVisible = false
    },
    confirmResult: function() {
      this.showConfirm = false;
      this.submitResult()
      this.completeOption = true
      this.dialogVisible = false
      this.surveyConfirmed = true
      this.survey.doComplete()
      localStorage.setItem(this.saveKey + '.status', 'completed')
      localStorage.setItem(this.saveKey + '.modified', Date.now().toLocaleString())
    },
    submitResult: function() {
      let uploadResult = {
        survey: this.surveyID,
        customerName: this.accountName,
        customerAddress: this.customerAddress || '',
        contract_name: this.contractName || this.filename,
        partner_name: this.partnerName,
        partner_address: this.partnerAddress,
        partnerName: this.partnerName,
        partnerAddress: this.partnerAddress,
        auftragsgeber: this.auftragsgeber,
        result_body: this.resultBody,
        // sorted_result: JSON.stringify({'resultOverview':this.resultOverview, 'overviewComment': this.generalComment, 'organizedResult': this.organizedResult, 'auditResult': this.auditResult}),
        sorted_result: JSON.stringify({ 'organizedResult': this.organizedResult, 'auditResult': this.auditResult, 'auditComment': this.surveyComment }),
        document_url: this.contractName || this.filename,
        createdby: this.id,
        remarks: this.remarks,
        gapInput: this.gapInput,
        statusSign: this.statusSign,
        partner_id: this.partnerID,
        tom_result: this.resultObject ? this.resultObject.tom_results : {},
      }
      if (this.resultObject !== undefined) {
        uploadResult['id'] = this.resultObject.id
      }
      const that = this
      service.request({
        url: '/survey/v1/surveyresult/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: uploadResult
      }).then(function(response) {
        that.$vToastify.success('Ergebnisse erfolgreich hochgeladen. Bericht wird erstellt!')
        that.surveyResponse = response.data
        that.$router.push({ name: 'avv-confirm', params: { surveyResponse: that.surveyResponse }})
      }).catch(function(err) {
        console.log(err)
      })
    },
    answerNotify: function(title, msg) {
      const h = this.$createElement
      this.$notify({
        title: title,
        message: h('i', { style: 'color: teal' }, msg)
      })
    },
    closeValidationPopupIfOutside: function(event) {
      // Check if the click happened outside the popup
      const popup = this.$el.querySelector('.validation-tooltip');
      if (popup && !popup.contains(event.target)) {
        this.closeValidationPopup();
      }
    },
    closeValidationPopup: function() {
      this.showValidationPopup = false;
      // Clean up the event listener when closed
      document.removeEventListener('click', this.closeValidationPopupIfOutside);
    },
    handleClose: function(done) {
      done()
    },
    fillOrganizedResult: function(surveyResult) {
      const resultList = JSON.parse(surveyResult)
      let commentKey = ''
      let removeKeys = []
      Object.keys(this.organizedResult).forEach((key) => {
        removeKeys = []
        this.organizedResult[key].points = 0;
        this.organizedResult[key].content.forEach((question) => {
          commentKey = `${question.name}-Comment`
          try {
            if (question.name in resultList) {
              if (question.type === 'radiogroup') {
                question.answer = this.resultDesc[question.name][resultList[question.name]]
                if (resultList[question.name].includes('no')) {
                  question.color = failed
                  question.result = 'failed'
                  this.organizedResult[key].result = 'failed'
                  this.organizedResult[key].color = failed
                  this.auditResult = 'failed'
                } else if (resultList[question.name].includes('others')) {
                  question.color = others
                  question.result = 'others'
                  this.organizedResult[key].result = 'others'
                  this.organizedResult[key].color = others
                  this.auditResult = 'others'
                } else {
                  this.organizedResult[key].points++
                }
              } else {
                const answers = []
                let answerResult = true
                resultList[question.name].forEach((item) => {
                  answers.push(this.resultDesc[question.name][item])
                  if (item.includes('no')) {
                    question.color = failed
                    question.result = 'failed'
                    this.organizedResult[key].result = 'failed'
                    this.organizedResult[key].color = failed
                    answerResult = false
                    this.auditResult = 'failed'
                  } else if (item.includes('others')) {
                    question.color = others
                    question.result = 'others'
                    this.organizedResult[key].result = 'others'
                    this.organizedResult[key].color = others
                    answerResult = false
                    this.auditResult = 'others'
                  }
                })
                question.answer = answers.join(', \n')
                if (answerResult) this.organizedResult[key].points++
              }
            }
            else {
              removeKeys.push(question.name)
            }
          }
          catch (error) {
            console.log(error)
            console.log(question.name)
            this.$vToastify.error(`Etwas lief schief: ${error}`)
          }
          if (commentKey in resultList) question.comment = resultList[commentKey]
        })
        if (removeKeys.length > 0) {
          this.organizedResult[key].content = this.organizedResult[key].content.filter((question) => !removeKeys.includes(question.name))
        }
      })
    }
  }
}
</script>

<style>

  #surveyContainer {
    font-family: Tahoma, Helvetica, Arial, sans-serif;
    text-align: left;
    font-size: 0.8rem;
}
  #surveyContainer .questiontitle {
    font-size: 1rem;
  }
  .radio {
    font-size: 0.6rem;
  }
  #surveyContainer .sd-body.sd-body--static {
    max-width: 100rem!important;
  }
  #surveyContainer ol li {
    list-style: decimal!important;
    margin-left: 1rem!important;
  }
  #surveyContainer .sd-question__description {
    font-size: 14px!important;
  }
  #surveyContainer .sv_q_erbox {
    background-color: red;
    color: red;
  }
  #surveyContainer table {
  font-family: 'Tahoma', arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

  #surveyContainer td, th {
  text-align: center;
  padding: 8px;
}

  #surveyContainer tr:nth-child(even) {
  background-color: #dddddd;
}
  .ired {
    color: red
  }
  .igreen {
    color: green
  }
  #surveyContainer h5.dialogtitle {
    color: #7a4c28;
    font-weight: bold;
  }
  #surveyContainer .sv_p_root > .sv_row {
    border-bottom: 1px solid #92be05;
  }
  #surveyContainer .sv_p_root > .sv_row:nth-child(odd) {
      background-color: white;
    }

  #surveyContainer .sv_p_root > .sv_row:nth-child(even) {
    background-color: #ebeef5;
  }
  #surveyContainer .sv_p_root > .sv_page_title {
    font-weight: 900;
  }
  #surveyContainer .sd-body .sd-body__page {
    margin-left: auto!important;
    margin-right: auto!important;
    max-width: fit-content!important;
  }
  #surveyContainer .sd-element .sd-element-yes:hover {
    background-color: rgba(0,255,0,0.4);
  }
  #surveyContainer .sd-element .sd-element-no:hover {
    background-color: rgba(255,0,0,0.4);
  }
  #surveyContainer .surveyMenu {
    position: fixed;
    top: 80px;
    right: 20px;
  }
  .sd-question__comment-area textarea.sd-comment {
    min-height: 15em!important;
  }

  .validation-tooltip {
    position: absolute;
    transform: translateY(-100%); /* Pushes the element upwards above the comment field */
    background-color: #fdfdfd;
    padding: 15px 35px 15px 15px; /* Extra right padding so text doesn't hit the X button */
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 600px;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 6px 16px rgba(0,0,0,0.15);
    z-index: 9999; /* Keeps it above everything else */
  }

  .validation-close {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 22px;
    cursor: pointer;
    color: #999;
    line-height: 1;
  }

  .validation-close:hover {
    color: #d9534f;
  }

  .validation-content {
    font-size: 0.85rem;
    color: #333;
  }
</style>
